export default __webpack_public_path__ + "static/media/placeholderImage.21247c88.svg";